import React from 'react';
import JDImage from '@/components/jd-img';
import './index.less';

const JD_DETAIL_URL = 'https://item.jd.com/';

interface ProductinfoInTypes {
  sku: string;
  img: string;
  goodsName: string;
  price: string;
  stock: string;
}

function ProductinfoInTable(props: ProductinfoInTypes) {
  const { sku, img, goodsName, price, stock } = props;
  return (
    <div className="acore-goods-info">
      <div>sku编号:{sku}</div>
      <div className="acore-goods-info-layout">
        <JDImage src={img} width={60} height={60} />
        <div className="acore-goods-info-right">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={JD_DETAIL_URL + sku + '.html'}
            className="acore-goods-info-goodsname"
          >
            {goodsName}{' '}
          </a>
          <div className="acore-goods-price-stock ellipsis-1-line">
            <span style={{ marginRight: '10px' }}>
              前台京东价:
              <span className="acore-goods-price">¥{price}</span>
            </span>
            <span>
              库存:
              <span className="acore-goods-stock">{stock}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductinfoInTable;
